import React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';

import { Alert, Box, TextField, Typography } from '@mui/material';

import Autocomplete from '@mui/material/Autocomplete';

import { Lab } from '../../lab';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>;
  lab: Lab | undefined;
  labs: Lab[];
  setLab: React.Dispatch<React.SetStateAction<Lab | undefined>>;
  validate: () => void;
}

const StepLabAssignment = ({ classes, lab, labs, setLab, validate }: Props): React.ReactElement => {
  return (
    <>
      <div className={classes.root}>
        <Typography className={classes.header} variant="h4">
          Lab
        </Typography>
        {labs.length === 1 && lab && <Alert severity="info">Your organisation is assigned to only one lab, which has been automatically selected.</Alert>}

        {labs.length > 1 && <Alert severity="info">Your organisation is assigned to more than one lab. Please select the one you are sending this case to</Alert>}
        <Box mt={2}>
          <Autocomplete
            data-qa="lab-assignment-list"
            options={labs}
            disabled={labs.length === 1}
            getOptionLabel={(option: Lab) => option.name}
            value={labs.find((i) => i.id === lab?.id)}
            autoComplete
            onBlur={() => validate()}
            onChange={(_: unknown, newValue: Lab | null) => {
              setLab(newValue || undefined);
            }}
            renderInput={(params) => <TextField data-qa="lab-assignment-input" {...params} label="Lab assignment" name="lab-assignment" helperText={lab ? '' : 'Select a lab'} />}
          />
        </Box>
      </div>
    </>
  );
};

export default withStyles(styles)(StepLabAssignment);
